<template>
  <Section medium>
    <div class="footer-wrapper">
      <p class="footer">&copy; Yonder Dynamics, 2026</p>
    </div>
    <v-spacer />
    <div class="footer-wrapper">
      <a href="mailto:yonderdynamics@ucsd.edu" class="footer">
        <p class="footer">yonderdynamics@ucsd.edu</p>
      </a>
    </div>
  </Section>
</template>

<script>
import Section from '@/components/Section.vue';

export default {
  name: 'Footer',

  components: {
    Section,
  },
};
</script>

<style scoped>
.footer-wrapper {
  margin-left: 10%;
  margin-right: 10%;
}
.footer {
  margin-bottom: 0px !important;
  color: white;
  font-size: 20px;
}
a {
  text-decoration: none;
}
</style>
